import { z } from 'zod';
import { parseFiniteNumber } from '../../parse-finite-number.js';
/** A form's decimal string checked by the same number schema the API uses, so the string stays a string and the two cannot drift. */
export const numberStringInput = (numberSchema, label) => z.string({ error: `${label} is required.` }).superRefine((value, context) => {
    const isBlank = value.trim() === '';
    const parsed = isBlank ? undefined : parseFiniteNumber(value);
    if (!isBlank && parsed === undefined) {
        context.addIssue({ code: 'custom', message: `${label} must be a number.`, path: [] });
        return;
    }
    const result = numberSchema.safeParse(parsed);
    if (result.success)
        return;
    for (const issue of result.error.issues) {
        context.addIssue({ code: 'custom', message: issue.message, path: [] });
    }
});
//# sourceMappingURL=number-string-input.js.map